// removed by extract-text-webpack-plugin
module.exports = {"cell":"CardComparisonRow__cell","left":"CardComparisonRow__left","right":"CardComparisonRow__right","row":"CardComparisonRow__row"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/CardComparisonContainer/components/CardComparisonRow/CardComparisonRow.tablet.css
// module id = 1312
// module chunks = 8